export default __webpack_public_path__ + "static/media/about-globe-icon.c41a0305.svg";